export default "__VITE_ASSET__CoOcuZLM__"